import { canonicalCrowdexAcpAgentId } from '@crowdex/agent-runtime/identity';

/**
 * Whether a persona (a saved agent) runs on the conversation's own runtime (design D51). Then it
 * takes a real turn of the conversation: streamed in the thread, with its tools, its approvals,
 * Stop. On another runtime it cannot: the conversation's agent session is that runtime's, and a
 * turn of another one would need its own session in the same conversation, which a runtime does
 * not have. Its reply is then generated aside, read-only and without tools, and says so.
 *
 * Two cold starts decide nothing on their own:
 * - The saved agents not read yet (the page just loaded): the composer and the transport wait for
 *   `readAgentPersonas()`, so a persona's turn is never taken for an aside, nor dropped.
 * - The conversation's agent not started yet (a new conversation, or a copy "from here"): a
 *   persona on its runtime takes the first turn as any message does, once the agent is ready (the
 *   edited message of a copy waits for it in `usePendingMessageDrain`); an aside needs the
 *   conversation stored, so before its first turn the composer keeps the draft and says why.
 */
export function personaSharesRuntime(personaAgentId: string, conversationAgentId: string): boolean {
  return (
    canonicalCrowdexAcpAgentId(personaAgentId) === canonicalCrowdexAcpAgentId(conversationAgentId)
  );
}

/** The agent a page's place runs: this machine's agent, or the cloud agent. */
export function placeAgentId(place: { agent: { id: string } } | { agentId: string }): string {
  return 'agent' in place ? place.agent.id : place.agentId;
}
